// Group labels are the contract between the middleware's fixed two-group model
// (To-Do / Completed) and the tabs that render them.
//
// New mirrors of middleware-authored values belong in `src/model/middleware-types.ts`
// (where TODO_GROUP_LABEL now lives); this one predates that rule and is left in
// place rather than moved by an unrelated change.
export const COMPLETED_GROUP_LABEL = 'Completed'
